import { useMemo } from 'react'
import { reduce, path, includes } from 'ramda'
import { shallowEqual, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { FavPanelView } from 'app/common/components/FavPanel'
import getAppTranslateIdWithPrefix from 'app/components/Subs/i18n/getAppTranslateIdWithPrefix'
import { APP_POLLS } from 'app/common/constants/services'

import { useFavorites } from './useFavorites'


export type Fav = {
  link: string,
  title: string,
  active: boolean,
  props?: Object,
}

type Props = {
  studentID: string
}

const AnimatedFavorites = ({ studentID }: Props) => {
  const pathname = window.location.pathname
  const { t } = useTranslation('subs')
  const favorites = useFavorites(studentID)

  const currentStudentId = useSelector((state: any) => state.settings.current.id, shallowEqual)
  const currentOrgType = useSelector(path(['students', 'data', currentStudentId, 'orgType']), shallowEqual)
  const currentSchoolId = useSelector((state: any) => state.settings.current.schoolId, shallowEqual)

  const fav = useMemo(() => {
    return reduce((acc, app) => {
      const appTranslateId = getAppTranslateIdWithPrefix(currentOrgType, app)
      const link = app === APP_POLLS ? `/app/${currentSchoolId}/fund` : `/apps/${currentStudentId}/${app}`
      acc.push({
        title: t(appTranslateId, { context: 'short' }),
        link,
        active: includes(link, pathname),
      })
      return acc
    }, [] as Array<Fav>, favorites)
  }, [currentOrgType, favorites, t, currentSchoolId, currentStudentId, pathname])

  return (
    <FavPanelView
      fav={fav}
      showConditionReg={/^\/(app|apps)(\/|$)/}
    />
  )
}

export default AnimatedFavorites
